//
// Angular
//
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';
import { HttpClient } from '@angular/common/http';
import { SharedDataService } from './shared-data.service';

@Injectable(
    {
        providedIn: 'root'
    }
)
export class AppChatService {

    constructor(private readonly httpClient: HttpClient,
        private readonly sharedService : SharedDataService,
        private readonly environment: EnvironmentConfiguration)
        {}
    private get dealerCode() {
        return this.sharedService.dealerCode;
    };
    
    //
    // load all chats
    //
    getAllMessages(dealTransactionId:string): Observable<any>{
        const path = this.environment.MST_BASE_SERVICE_URL + 'deals/dealers/' + this.dealerCode + '/offers/' + dealTransactionId+'?comments=true';
        return  this.httpClient.get(path);//.pipe(map(response => this.formateDate(response)));
     }

     //
     // send message
     //
     sendMessage(data:{
        dealTransactionId: string,
        userComment: string,
        consultantName: string
        }): Observable<any> {
        let request  = {    userRole: "SALES_MANAGER",
                            userComment: data.userComment,
                            visitedStatus:true,
                            givenBy: data.consultantName
        };
        const path = this.environment.MST_BASE_SERVICE_URL + 'deals/dealers/' + this.dealerCode + '/comments/' + data.dealTransactionId;
        return this.httpClient.put(path,request);
    }
}